import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function RugbyUnionNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Rugby Union",
    links: [
      {href: "/rugby-union", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

RugbyUnionNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default RugbyUnionNav



// WEBPACK FOOTER //
// ./modules/RugbyUnion/nav/RugbyUnionNav.js